<!-- Modals -->
<!-- Switch Division Modal -->
<app-deprecated-modal-form
    #switchDivisionModal
    [form]="switchDivisionForm"
    [label]="'Save'"
    (save)="switchDivision()"
    (cancel)="onCancel()"
    [headerText]="'Switch Division for ' + currentEmployeeBenefitPlan?.employee.firstName"
>
    <app-switch-benefit-division
        #switchDivisionForm
        [employeeBenefitPlan]="currentEmployeeBenefitPlan"
        [allDivisions]="benefitPlan.benefitPolicy?.divisions"
        (selectedBenefitDivision)="setNewDivision($event)"
    ></app-switch-benefit-division>
</app-deprecated-modal-form>

<!-- Switch Benefit Plan Modal -->
<app-deprecated-modal-form
    #switchPlanModal
    [form]="switchPlanForm"
    [label]="'Save'"
    (save)="switchBenefitPlan()"
    (cancel)="onCancel()"
    [headerText]="'Change Plan for ' + currentEmployeeBenefitPlan?.employee.firstName"
>
    <app-switch-benefit-plan
        #switchPlanForm
        [employeeBenefitPlan]="currentEmployeeBenefitPlan"
        [allBenefitPlans]="allBenefitPlans"
        (selectedBenefitPlan)="setNewBenefitPlan($event)"
    ></app-switch-benefit-plan>
</app-deprecated-modal-form>

<!-- Beneficiary Form Modal -->
<app-deprecated-modal #pdfPreviewModal tall="true">
    <app-pdf-viewer #pdfViewer></app-pdf-viewer>
</app-deprecated-modal>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <!--<app-pagination [total]="paginator.total"
                    [current]="paginator.page"
                    (pageChange)="paginator.page = $event">
    </app-pagination>-->

    <app-header title="Benefit Plan" [back]="true" backRoute="/benefits/plans" [menuService]="benefitShowMenuService">
        <div class="buttons">
            <ui-button *ngIf="!isEmpty" type="primary" url="new"
                ><mat-icon svgIcon="plus"></mat-icon>Add employees</ui-button
            >
        </div>
    </app-header>

    <app-table [table]="table" class="table" (menuItemSelected)="onTableMenuEvent($event)">
        <div class="empty">
            <img class="benefits-img" src="/assets/illustrations/benefits.png" />
            <h2 class="ui centered header">No employees assigned to this benefits plan</h2>
            <ui-button url="new" type="primary" class="assignEmployeesButton">
                <mat-icon svgIcon="plus"></mat-icon> Add employees</ui-button
            >
        </div>
    </app-table>
</div>
